import React, { useEffect, useState } from "react";
import { Loader2 } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { reApi, errMsg } from "@/lib/residentApi";
import { inputCls, labelCls, GoldButton, GhostButton, ErrorLine } from "./ui";

const FIELDS = [["first_name", "First name"], ["last_name", "Last name"], ["preferred_name", "Preferred name"], ["email", "Email"], ["dob", "Date of birth"]];

/** Delete a wrong signed copy for good, fix the resident's details, and send the same document to sign again. */
export default function ReplaceSigned({ doc, onClose, onDone }) {
  const [orig, setOrig] = useState(null);
  const [details, setDetails] = useState({});
  const [reason, setReason] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(null);
  useEffect(() => { reApi.get(`/documents/signed/${doc.id}/replace`).then((d) => { setOrig(d.details); setDetails(d.details); }).catch((e) => setError(errMsg(e))); }, [doc.id]);
  const submit = async () => {
    setBusy(true); setError(null);
    const changed = Object.fromEntries(Object.entries(details).filter(([k, v]) => v !== orig[k]));
    try { await reApi.post(`/documents/signed/${doc.id}/replace`, { reason, details: changed }); onDone(); }
    catch (e) { setError(errMsg(e)); setBusy(false); }
  };
  return (
    <Dialog open onOpenChange={(o) => !o && !busy && onClose()}>
      <DialogContent data-testid="replace-signed-dialog" className="bg-[#0b0f1f] border-white/10 text-nex-silver max-w-lg max-h-[90vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle className="text-white">Replace signed document</DialogTitle>
          <DialogDescription className="text-nex-muted text-xs">"{doc.title}" will be deleted permanently and can't be recovered. Fix any details below, then the same document goes back to the resident to sign again.</DialogDescription>
        </DialogHeader>
        {!orig ? (!error && <Loader2 className="h-4 w-4 animate-spin" />) : (
          <div className="grid grid-cols-2 gap-3">
            {FIELDS.map(([k, label]) => (
              <label key={k} className={k === "email" ? "col-span-2" : ""}><span className={labelCls}>{label}</span>
                <input data-testid={`replace-${k}`} type={k === "dob" ? "date" : "text"} value={details[k] || ""} onChange={(e) => setDetails({ ...details, [k]: e.target.value })} className={inputCls} /></label>
            ))}
            <label className="col-span-2"><span className={labelCls}>Reason for replacing</span>
              <textarea data-testid="replace-reason" rows={2} value={reason} onChange={(e) => setReason(e.target.value)} placeholder="e.g. Last name was misspelled" className={inputCls} /></label>
          </div>
        )}
        <ErrorLine testId="replace-error">{error}</ErrorLine>
        <div className="flex justify-end gap-2">
          <GhostButton data-testid="replace-cancel" onClick={onClose} disabled={busy}>Cancel</GhostButton>
          <GoldButton data-testid="replace-confirm" onClick={submit} disabled={busy || !orig || reason.trim().length < 3}>
            {busy && <Loader2 className="h-3 w-3 animate-spin" />} Delete & send to re-sign</GoldButton>
        </div>
      </DialogContent>
    </Dialog>
  );
}
